// Copyright (c) 2026, Help Mobility. License: MIT. See license.txt
//
// The assistant on the website: for someone signed in who may use it on the Desk, a ✨ bubble
// in the corner opens a card with the Desk's chat page in it (/app/ai, embedded) - the same
// chats as on the Desk. The page they're on goes with their messages: its address, title and
// text. The chat they're in is kept as they move between pages.
(function () {
	"use strict";

	const CHAT_KEY = "ai_assistant_web_chat";
	const OPEN_KEY = "ai_assistant_web_open";
	const store = {
		get: (k) => {
			try {
				return sessionStorage.getItem(k);
			} catch (e) {
				return null;
			}
		},
		set: (k, v) => {
			try {
				if (v == null) sessionStorage.removeItem(k);
				else sessionStorage.setItem(k, v);
			} catch (e) {
				// private window: not kept between pages
			}
		},
	};
	const signedIn = () => {
		const m = document.cookie.match(/(?:^|;\s*)user_id=([^;]*)/);
		return !!m && decodeURIComponent(m[1]) !== "Guest";
	};
	const esc = (s) => String(s == null ? "" : s).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" })[c]);

	function start() {
		if (!signedIn() || window.self !== window.top || location.pathname.startsWith("/app")) return;
		fetch("/api/method/advanced_ai_assistant.website.access", { headers: { Accept: "application/json" }, credentials: "same-origin" })
			.then((r) => (r.ok ? r.json() : {}))
			.then((body) => {
				const info = body && body.message;
				if (info && info.ok) mount(info.name || "Assistant");
			})
			.catch(() => {});
	}

	function mount(name) {
		const bubble = document.createElement("button");
		bubble.className = "ai-web-bubble";
		bubble.type = "button";
		bubble.title = name;
		bubble.setAttribute("aria-label", name);
		bubble.textContent = "✨";
		document.body.appendChild(bubble);
		let card = null;

		const pageInfo = () => {
			const main = document.querySelector("main, .page-content, .web-page-content, #page-content") || document.body;
			return { type: "ai-page", path: location.pathname + location.search, title: document.title,
				text: (main.innerText || "").replace(/\n{3,}/g, "\n\n").slice(0, 12000) };
		};
		const open = () => {
			if (!card) {
				card = document.createElement("div");
				card.className = "ai-web-card";
				const chat = store.get(CHAT_KEY);
				// The chat page's own header is the card's (its title, new chat, ↗ to the Desk, ✕).
				card.innerHTML = `<iframe class="ai-web-frame" title="${esc(name)}" src="/app/ai${
					chat ? "/" + encodeURIComponent(chat) : ""
				}?embed=1"></iframe>`;
				document.body.appendChild(card);
				const frame = card.querySelector("iframe");
				// The page they're on, for the chat (and again once the chat page is ready).
				const tell = () => frame.contentWindow && frame.contentWindow.postMessage(pageInfo(), location.origin);
				frame.addEventListener("load", tell);
				card._tell = tell;
			}
			card.classList.add("open");
			bubble.classList.add("on");
			bubble.textContent = "✕";
			store.set(OPEN_KEY, "1");
		};
		const close = () => {
			if (card) card.classList.remove("open");
			bubble.classList.remove("on");
			bubble.textContent = "✨";
			store.set(OPEN_KEY, null);
		};
		bubble.addEventListener("click", () => (card && card.classList.contains("open") ? close() : open()));
		window.addEventListener("message", (e) => {
			if (e.origin !== location.origin || !e.data) return;
			if (e.data.type === "ai-chat" && e.data.chat) store.set(CHAT_KEY, e.data.chat);
			if (e.data.type === "ai-close") close();
			if (e.data.type === "ai-ready" && card && card._tell) card._tell();
		});
		document.addEventListener("keydown", (e) => {
			if ((e.ctrlKey || e.metaKey) && (e.key === "j" || e.key === "J")) {
				e.preventDefault();
				card && card.classList.contains("open") ? close() : open();
			}
		});
		// Open on the next page too, if it was open when they left this one.
		if (store.get(OPEN_KEY)) open();
	}

	if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
	else start();
})();
